import { render, staticRenderFns } from "./InvocationNetworkCard.vue?vue&type=template&id=2ffe614a&scoped=true"
import script from "./InvocationNetworkCard.vue?vue&type=script&lang=ts"
export * from "./InvocationNetworkCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffe614a",
  null
  
)

export default component.exports